import { Navigate, type RouteObject } from "react-router";
import { loginRoute } from "./auth";
import { dashboardRoutes } from "./dashboard";

export const routesSection: RouteObject[] = [
	// Auth
	loginRoute,
	// Dashboard
	...dashboardRoutes,
	// No Match
	{ path: "*", element: <Navigate to="/404" replace /> },
];
